/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ActionDefaultNode", ["StandardNode", "NodeFactory"], function (context, cls) {
  /**
   * AUI Node ActionDefault
   *
   * @class ActionDefaultNode
   * @memberOf classes
   * @extends classes.StandardNode
   */
  class ActionDefaultNode extends cls.StandardNode /** @lends classes.ActionDefaultNode.prototype */ {
    constructor(parent, tag, id, attributes, app) {
      super(parent, tag, id, attributes, app);
    }
  }
  cls.ActionDefaultNode = ActionDefaultNode;
  cls.NodeFactory.register("ActionDefault", ActionDefaultNode);
});
